export default __webpack_public_path__ + "static/media/jumboimg.d2e7a627.webp";